import { validate, setDefinicaoCorrente } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import { getDefinicao, pathRegistros } from '../../services/api-crud-dinamico'
import { messageActions } from '../../store/message'
import storage from '../../services/stoage.service'
import utils from '../../utils'

// basePath é dinâmico: definido por carregarTela/carregarDefinicao conforme a chave da rota
const crud = build(validate, pathRegistros(''))
const prefix = 'crudCrudDinamico'

const actions = new Action(prefix, crud)
const newTypes = {
  RESET: `${prefix}reset`,
  SET_DEFINICAO: `${prefix}setDefinicao`,
}

const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.setDefinicao = (chave, definicao) => {
  return {
    type: types.SET_DEFINICAO,
    payload: { chave, definicao },
  }
}

/**
 * Carrega a definição da chave e em seguida a listagem.
 * Usado pela tela de listagem (substitui o load() padrão, que depende de
 * defaultColumns/estado salvo por menu).
 */
actions.carregarTela = (chave) => {
  return (dispatch, getState) => {
    dispatch(actions.reset())
    crud.basePath = pathRegistros(chave)
    getDefinicao(chave)
      .then(({ data }) => {
        setDefinicaoCorrente(data)
        dispatch(actions.setDefinicao(chave, data))
        const state = getState()[`${prefix}State`]
        const maxPadrao = utils.getLinhasPadraoPorPagina(storage.getCompany(), storage.getUnit())
        dispatch(actions.paginate({ index: 0, max: (state && state.max) || maxPadrao }))
      })
      .catch(() => {
        dispatch(
          messageActions.messageShowMessages([
            { sticky: true, severity: 'error', detail: `Tela dinâmica não encontrada: ${chave}` },
          ])
        )
      })
  }
}

/**
 * Carrega apenas a definição (tela de formulário).
 */
actions.carregarDefinicao = (chave, onSuccess) => {
  return (dispatch) => {
    crud.basePath = pathRegistros(chave)
    getDefinicao(chave)
      .then(({ data }) => {
        setDefinicaoCorrente(data)
        dispatch(actions.setDefinicao(chave, data))
        if (onSuccess) {
          onSuccess(data)
        }
      })
      .catch(() => {
        dispatch(
          messageActions.messageShowMessages([
            { sticky: true, severity: 'error', detail: `Tela dinâmica não encontrada: ${chave}` },
          ])
        )
      })
  }
}

/**
 * Exclui os registros selecionados via POST {chave}/removeall e recarrega a listagem.
 * (substitui o removeAll do actions.factory, que envia lista vazia de oids)
 */
actions.excluirSelecionados = (chave) => {
  return (dispatch, getState) => {
    const state = getState()[`${prefix}State`]
    const oids = (state.selectedRecords || []).map((registro) => registro.oid).filter(Boolean)
    if (oids.length === 0) {
      dispatch(
        messageActions.messageShowMessages([
          { sticky: false, severity: 'warn', detail: 'Não foram selecionados registros' },
        ])
      )
      return
    }
    crud
      .removeAll(oids)
      .then(() => {
        dispatch(
          messageActions.messageShowMessages([
            { sticky: false, severity: 'success', detail: 'Registros removidos com sucesso' },
          ])
        )
        dispatch(actions.clearSelectedRecords())
        dispatch(actions.carregarTela(chave))
      })
      .catch((err) => {
        const detail = (err.response && err.response.data) || 'Erro ao remover registros'
        dispatch(messageActions.messageShowMessages([{ sticky: true, severity: 'error', detail }]))
      })
  }
}

export { types, actions }
